<template>
  <div class="grouped-site-chargers px-3 py-2">
    <div v-if="chargerList.length > 0" class="custom-table-design">
      <el-table
        :data="chargerList"
        :fit="true"
        stripe
        row-key="id"
        max-height="280"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
      <el-table-column
          :label="'Motion Charger ID'"
          :prop="'id'"
          min-width="120"
          show-overflow-tooltip
          sortable
        >
          <template #default="scope">
            {{ displayValue(scope.row.id) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Charger name'"
          :prop="'charger_name'"
          min-width="180"
          show-overflow-tooltip
          sortable
        >
          <template #default="scope">
            {{ displayValue(scope.row.charger_name) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Year added'"
          :prop="'year_added'"
          min-width="120"
          sortable
        >
          <template #default="scope">
            {{ displayValue(scope.row.year_added) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Decommissioning date'"
          :prop="'decommissioning_date'"
          min-width="170"
          sortable
        >
          <template #default="scope">
            {{ formatIsoDate(scope.row.decommissioning_date) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Active until'"
          :prop="'active_until'"
          min-width="140"
          sortable
        >
          <template #default="scope">
            {{ formatIsoDate(scope.row.active_until) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Included'"
          :prop="'is_included'"
          min-width="110"
          sortable
        >
          <template #default="scope">
            {{ formatIncluded(scope.row.is_included) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Change details'"
          :prop="'change_details'"
          min-width="180"
          show-overflow-tooltip
          sortable
        >
          <template #default="scope">
            {{ displayValue(scope.row.change_details) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Change date'"
          :prop="'change_date'"
          min-width="140"
          sortable
        >
          <template #default="scope">
            {{ formatIsoDate(scope.row.change_date) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <p v-else class="moderat-white mb-0 py-2">No chargers on this site</p>
  </div>
</template>

<script>
import { convertTimezone } from "../common/common-tools";

export default {
  name: "GroupedSiteChargersTable",
  props: {
    chargers: {
      type: Array,
      default: () => [],
    },
    includedFilter: {
      type: String,
      default: "all",
    },
  },
  computed: {
    chargerList() {
      const chargers = Array.isArray(this.chargers) ? this.chargers : [];
      if (this.includedFilter === "included") {
        return chargers.filter((charger) => this.isChargerIncluded(charger));
      }
      if (this.includedFilter === "not_included") {
        return chargers.filter((charger) => this.isChargerNotIncluded(charger));
      }
      return chargers;
    },
  },
  methods: {
    isChargerIncluded(charger) {
      return charger?.is_included === true
        || String(charger?.is_included).toUpperCase() === "TRUE"
        || String(charger?.is_included).toUpperCase() === "YES";
    },
    isChargerNotIncluded(charger) {
      return charger?.is_included === false
        || String(charger?.is_included).toUpperCase() === "FALSE"
        || String(charger?.is_included).toUpperCase() === "NO";
    },
    displayValue(value) {
      if (value == null || String(value).trim() === "") {
        return "—";
      }
      return String(value);
    },
    formatIsoDate(value) {
      if (value == null || String(value).trim() === "") {
        return "—";
      }
      try {
        const formatted = convertTimezone(String(value).trim(), "date");
        if (!formatted || String(formatted).toLowerCase().includes("invalid")) {
          return "—";
        }
        return formatted;
      } catch {
        return "—";
      }
    },
    formatIncluded(value) {
      if (value === true || String(value).toUpperCase() === "TRUE" || String(value).toUpperCase() === "YES") {
        return "Yes";
      }
      if (value === false || String(value).toUpperCase() === "FALSE" || String(value).toUpperCase() === "NO") {
        return "No";
      }
      return "—";
    },
  },
};
</script>
